var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-module-tmp"},[_c('div',{staticClass:"f fm mb12 mt20"},[_c('h2',[_vm._v("トレーニング設定")])])])}]

export { render, staticRenderFns }